module.exports = __webpack_public_path__ + "media/images/front/pc/institution-search/male-5dd7885f2e207c0645d266be6e73bdc5.svg";